import { Col, Row } from 'antd';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React from 'react';
import { RoleEnum } from 'types/user';

// import ByAppointmentStatusFilterBar from './ByAppointmentStatusFilterBar';
import ByDateAndLocationFilterBar from './ByDateAndLocationFilterBar';
import ByStateFilterBar from './ByStateFilterBar';
import ClientSpecificFilters from './ClientSpecificFilters';

const AppointmentFilterBars: React.FC = () => {
  const { role: userRole } = useCurrentLoggedInUser(); // test nha
  const isClient = userRole === RoleEnum.CLIENT;

  return (
    <Row className='gx-m-0 gx-p-0'>
      <Col className='gx-mr-3 gx-p-0' span={24}>
        <div className='flex flex-col sm:flex-row items-center w-full'>
          <ByDateAndLocationFilterBar />
          {isClient && <ClientSpecificFilters />}
        </div>
      </Col>
      <Col span={24} className='gx-p-0' style={{ marginTop: 15 }}>
        <ByStateFilterBar />
      </Col>
    </Row>
  );
};

export default React.memo(AppointmentFilterBars);
